<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Vytvořit nového spolupracovníka</h2>
          </v-card-title>
          <v-card-text class="pa-0" :class="{'pb-2' : $vuetify.breakpoint.smAndUp}">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Jméno" v-model="newItem.jmeno" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Příjmení" v-model="newItem.prijmeni" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <typosoby v-model="newItem.typ_osoby"></typosoby>
                </v-flex>
                <v-flex xs12 sm6 class="pt-1">
                  <v-switch label="Makléř" v-model="newItem.makler" class="mx-2"></v-switch>
                  <!-- <v-checkbox label="Makléř" v-model="newItem.makler" class="mx-2"></v-checkbox> -->
                </v-flex>
                <v-flex xs12 sm6 v-if="newItem.typ_osoby=='po'">
                  <v-text-field label="Název firmy" v-model="newItem.nazev_firmy" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Oslovení" v-model="newItem.osloveni" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-2">
                <v-flex xs12>
                  <v-flex xs12>
                    <osobasearch v-model="newItem.nadrizeny_spolupracovnik_id" label="Nadřízený spolupracovník" class="mx-2"></osobasearch>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending">Vytvořit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex grow>
                <h3>Přehled spolupracovníků</h3>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" small :href="api_url_admin+'export/spolupracovnici/xlsx?'+export_query" target="_blank" class="ma-0" depressed>Exportovat</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3" align-center>
              <v-flex xs12 sm2>
                <v-text-field
                  label="Hledat dle jména"
                  class="mx-2"
                  v-model="search"
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field
                  label="Hledat dle adresy"
                  class="mx-2"
                  v-model="adresa_search"
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <osobasearch label="Nadřízený spolupracovník" v-model="spolupracovnik" class="mx-2" :spolupracovnik="true"></osobasearch>
              </v-flex>
              <v-flex xs12 sm3 md2>
                <v-checkbox label="Noví klienti" class="mx-2" v-model="novy_ucet"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm4 md3 class="text-xs-center text-sm-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick">
                  <v-icon class="mr-2">add</v-icon>
                  Vytvořit spolupracovníka
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <router-link :to="{ path: '/klienti/'+props.item.id }">{{ props.item.nazev_osoby }}</router-link>
                    <v-chip color="blue" v-if="props.item.makler" small dark style="pointer-events: none;" class="mx-2">Makléř</v-chip>
                  </td>
                  <td><span v-if="props.item.typ_osoby=='po'">Právnická osoba</span><span v-else-if="props.item.typ_osoby=='fo'">Fyzická osoba</span><span v-else-if="props.item.typ_osoby=='osvc'">OSVČ</span></td>
                  <td>{{ props.item.cela_adresa }}</td>
                  <td class="text-center">
                    <router-link :to="{ path: '/klienti/'+props.item.id }" target="_blank">
                      <v-btn color="primary" class="elevation-0">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      updateItem: {},
      headers: [
          { text: 'Název osoby', value: 'nazev_osoby' },
          { text: 'Typ osoby', value: 'typ_osoby' },
          { text: 'Adresa', value: 'cela_adresa' },
          { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
        ],
      items: [],
      loadingTable: true,
      search: "",
      adresa_search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "nazev_osoby",
        totalItems: 0
      },
      valid: true,
      dialogCreate: false,
      sending: false,
      dialogInit: { nazev: null, nazev_firmy: null, jmeno: null, prijmeni: null, typ_osoby: null, nadrizeny_spolupracovnik_id: null, osloveni: null, makler: false },
      newItem: null,
      // Dialog create end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      spolupracovnik: null,
      export_query: "",
      novy_ucet: false
    }
  },
  watch: {
    search () {
      this.queryList();
      this.makeExportQuery();
    },
    novy_ucet () {
      this.queryList();
      this.makeExportQuery();
    },
    adresa_search () {
      this.queryList();
      this.makeExportQuery();
    },
    pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
    spolupracovnik () {
      this.pagination.page = 1;
      this.load();
      this.makeExportQuery();
    }
  },
  computed: {
    api_url_admin () {
      return window.api.$api_url;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    if (this.getQuery("n") == "1") {
      this.novy_ucet = true;
    }
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("osoby/search", {
        pagination: this.pagination,
        s: this.search,
        adresa: this.adresa_search,
        echo: this.counter,
        spolupracovnik: true,
        poradce: this.spolupracovnik,
        novy_ucet: this.novy_ucet
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        this.newItem.klient = false;
        this.newItem.spolupracovnik = true;
        window.API.post("osoby", this.newItem).then(function(body) {
          if (body.inserted) {
            this.$router.push({path:"/klienti/"+body.data.id});
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    makeExportQuery () {
      this.export_query = [
        this.search != null && this.search.length > 0 ? "s=" + this.search : null,
        this.adresa_search != null && this.adresa_search.length > 0 ? "a=" + this.adresa_search : null,
        this.spolupracovnik != null && this.spolupracovnik.length > 0 ? "p=" + this.spolupracovnik : null,
        this.novy_ucet != null && this.novy_ucet == true ? "n=1" : null,
      ].filter((e) => { return e != null }).join("&");
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/KlientiSpolupracovnici/Spolupracovnici.vue